import React from "react";
import _ from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";

import Button from "components/Button";
import { connect } from "../../reduxConnector";
import companyInformationActions from "./actions";
import { URLS } from "constants/urlConstants";
import BackgroundBlock from "../deliveryNotes/partials/BackgroundBlock";
import Input from "components/Input";
import CNBDatePicker from "components/CNBDatePicker";

interface IState {
  [key: string]: any;
  error: any;
  touched: any;
  Number: string;

  Name: string;
  LegalForm: string;
  KvKNumber: string;
  OfficeNumber: string;
  MailAddress: string;
  correspondentieadres: string;
  vestigingsadres: string;
  afleveradres: string;
  BankAccount: string;
  BankAccountSwift: string;
  VATPostingGroup: string;
  Exporter: string;
  VATNumber: string;
  BKDNumber: string;
  NAKTNumber: string;
  GrowersAssociation: boolean;

  Certificates: Array<{
    Participation: string;
    RegistrationNumber: string;
    CertificationOrganization: string;
  }>;
  FytosanitairNumber: string;
  CNBMember: string;
  CNBMemberFrom: string;
  EDICode: string;
  DigitalCommunication: string;
}

class CompanyInformation extends React.Component<any, IState> {
  private baseState: IState;

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      isFormValid: false,
      error: null,
      touched: {},
      Number: "",
      Name: "",
      LegalForm: "",
      KvKNumber: "",
      OfficeNumber: "",
      MailAddress: "",
      GrowersAssociation: false,
      correspondentieadres: "",
      vestigingsadres: "",
      afleveradres: "",
      Certificates: [
        {
          Participation: "",
          RegistrationNumber: "",
          CertificationOrganization: "",
        },
      ],
      BankAccount: "",
      BankAccountSwift: "",
      VATPostingGroup: "",
      Exporter: "",
      VATNumber: "",
      BKDNumber: "",
      NAKTNumber: "",
      FytosanitairNumber: "",
      CNBMember: "",
      CNBMemberFrom: "",
      EDICode: "",
      DigitalCommunication: "",
    };
  }

  public componentDidMount = () => {
    const { getCompanyInformation, user } = this.props;
    getCompanyInformation();
  };

  public async componentDidUpdate(
    prevProps: Readonly<any>,
    prevState: Readonly<IState>,
    snapshot?: any
  ) {
    if (prevProps.companyInformation !== this.props.companyInformation) {
      const { companyInformation } = this.props;
      await this.mapDataToState(companyInformation);
      this.baseState = this.state;
    }
  }

  private async mapDataToState(companyInformation) {
    Object.entries(companyInformation).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        if (key === "Certificates") {
          const newValue = value.map((item) => ({
            Participation: item.Participation,
            RegistrationNumber: item.RegistrationNumber,
            CertificationOrganization: item.CertificationOrganization,
          }));
          this.setState({
            [key]: newValue,
          });
        } else {
          // check typeId of each array item
          companyInformation[key].forEach((item) => {
            switch (item.TypeId) {
              case "PostAdres":
                this.setState({
                  correspondentieadres:
                    item.Address1 +
                    ", " +
                    item.ZipCode +
                    ", " +
                    item.City +
                    ", " +
                    item.Country.Code,
                });
                break;
              case "VestigingsAdres":
                this.setState({
                  vestigingsadres:
                    item.Address1 +
                    ", " +
                    item.ZipCode +
                    ", " +
                    item.City +
                    ", " +
                    item.Country.Code,
                });
                break;
              case "LeverAdres":
                this.setState({
                  afleveradres:
                    item.Address1 +
                    ", " +
                    item.ZipCode +
                    ", " +
                    item.City +
                    ", " +
                    item.Country.Code,
                });
                break;
            }
          });
        }
      } else if (typeof value === "boolean" && key !== "GrowersAssociation") {
        this.setState({
          [key]: value ? "Ja" : "Nee",
        });
      } else if (typeof value === "object") {
        const _key = "Description";
        this.setState({
          [key]: value ? value[_key] : "",
        });
      } else {
        this.setState({
          [key]: value,
        });
      }
    });
  }

  private checkPermissionLevelAndNavigate = () => {
    // ideally we would check if the user has the correct role to edit the company information
    const { history } = this.props;
    history.push(URLS.COMPANY_INFORMATION_EDIT);
    return;
  };

  public render() {
    const {
      Name,
      Number,
      LegalForm,
      KvKNumber,
      MailAddress,
      OfficeNumber,
      correspondentieadres,
      vestigingsadres,
      afleveradres,
      BankAccount,
      BankAccountSwift,
      VATPostingGroup,
      Exporter,
      VATNumber,
      BKDNumber,
      NAKTNumber,
      FytosanitairNumber,
      CNBMember,
      CNBMemberFrom,
      // GrowersAssociation,
      EDICode,
      DigitalCommunication,
      Certificates,
    } = this.state;
    const { roles } = this.props;
    return (
      <div id="my-deliveries-pagee">
        <div className="child-header">
          <FormattedMessage id="COMPANY_DETAILS" tagName="h1" />
          {_.includes(roles, "GebruikersBeheer") && (
            <Button
              id="create-delivery-top"
              kind="primary"
              className="animate-bg bg-white"
              onClick={this.checkPermissionLevelAndNavigate}
            >
              COMPANY_INFORMATION_EDIT
            </Button>
          )}
        </div>

        <form id="new-cultivation-advice">
          <BackgroundBlock className="advice-form custom-header">
            <FormattedMessage id="COMPANY_DETAILS" tagName="h2" />
          </BackgroundBlock>
          <div className="line-below"></div>
          <div className="company-details-section">
            <div className="company-details-section-one">
              <Input
                name="Number"
                label="CLIENT_NR"
                placeholder="CLIENT_NR"
                value={Number}
                disabled
                isEditOrCreate={false}
              />
              <Input
                name="Name"
                label="COMPANY_NAME"
                placeholder="COMPANY_NAME"
                value={Name}
                readOnly
                isEditOrCreate={false}
              />
              <Input
                name="LegalForm"
                label="COMPANY_LEGAL_PERSON"
                placeholder="COMPANY_LEGAL_PERSON"
                value={LegalForm}
                isEditOrCreate={false}
                readOnly
              />
              <Input
                name="KvKNumber"
                label="COMPANY_KVK_NUMBER"
                placeholder="COMPANY_KVK_NUMBER"
                value={KvKNumber}
                isEditOrCreate={false}
                readOnly
              />
            </div>
            <div className="company-details-section-two">
              <Input
                name="OfficeNumber"
                label="COMPANY_PHONE"
                hasTooltip={true}
                tooltipText="COMPANY_PHONE_TOOLTIP"
                placeholder="COMPANY_PHONE"
                value={OfficeNumber}
                isEditOrCreate={false}
                readOnly
              />
              <Input
                name="MailAddress"
                hasTooltip={true}
                tooltipText="COMPANY_EMAIL_TOOLTIP"
                label="COMPANY_EMAIL"
                placeholder="COMPANY_EMAIL"
                value={MailAddress}
                isEditOrCreate={false}
                readOnly
              />
              <Input
                name="correspondentieadres"
                label="COMPANY_CORRESPONDENCE_ADDRESS"
                placeholder="COMPANY_CORRESPONDENCE_ADDRESS"
                className="info-address"
                value={correspondentieadres}
                isEditOrCreate={false}
                readOnly
              />
              <Input
                name="vestigingsadres"
                label="COMPANY_BUSINESS_ADDRESS"
                placeholder="COMPANY_BUSINESS_ADDRESS"
                className="info-address"
                isEditOrCreate={false}
                value={vestigingsadres}
                readOnly
              />
              <Input
                name="afleveradres"
                label="COMPANY_DELIVERY_ADDRESS"
                placeholder="COMPANY_DELIVERY_ADDRESS"
                className="info-address"
                isEditOrCreate={false}
                value={afleveradres}
                readOnly
              />
            </div>
          </div>

          <BackgroundBlock className="advice-form custom-header">
            <FormattedMessage id="COMPANY_FINANCIAL" tagName="h2" />
          </BackgroundBlock>
          <div className="line-below"></div>
          <div className="company-details-section">
            <div className="company-details-section-one">
              <Input
                name="BankAccount"
                label="COMPANY_IBAN"
                placeholder="COMPANY_IBAN"
                value={BankAccount}
                isEditOrCreate={false}
                readOnly
              />
              <Input
                name="BankAccountSwift"
                label="COMPANY_SWIFT"
                placeholder="COMPANY_SWIFT"
                value={BankAccountSwift}
                isEditOrCreate={false}
                readOnly
              />
            </div>
            <div className="company-details-section-two">
              <Input
                name="VATPostingGroup"
                label="COMPANY_BTW"
                placeholder="COMPANY_BTW"
                value={VATPostingGroup}
                isEditOrCreate={false}
                disabled
              />
              <Input
                name="Exporter"
                label="COMPANY_EXPORTER"
                placeholder="COMPANY_EXPORTER"
                value={Exporter}
                isEditOrCreate={false}
                disabled
              />
              <Input
                name="VATNumber"
                label="COMPANY_BTW_NUMBER"
                placeholder="COMPANY_BTW_NUMBER"
                value={VATNumber}
                isEditOrCreate={false}
                readOnly
              />
            </div>
          </div>

          <BackgroundBlock className="advice-form custom-header">
            <FormattedMessage id="COMPANY_INFORMATION" tagName="h2" />
          </BackgroundBlock>
          <div className="line-below"></div>
          <div className="company-details-section">
            <div className="company-details-section-one">
              <Input
                name="BKDNumber"
                label="COMPANY_BKD_NUMBER"
                placeholder="COMPANY_BKD_NUMBER"
                value={BKDNumber}
                isEditOrCreate={false}
                readOnly
              />
              <Input
                name="NAKTNumber"
                label="COMPANY_NAKT_NUMBER"
                placeholder="COMPANY_NAKT_NUMBER"
                value={NAKTNumber}
                isEditOrCreate={false}
                readOnly
              />
              <Input
                name="FytosanitairNumber"
                label="COMPANY_PHYTO_NUMBER"
                placeholder="COMPANY_PHYTO_NUMBER"
                value={FytosanitairNumber}
                isEditOrCreate={false}
                readOnly
              />
            </div>
            <div className="company-details-section-two">
              {Certificates.length > 0 && (
                <div className="section-array">
                  <FormattedMessage
                    id="COMPANY_CERTIFICATE_PARTICIPATION"
                    tagName="h4"
                    className="certificate-label"
                  />
                  <FormattedMessage
                    id="COMPANY_CERTIFICATE_REGISTRATION"
                    tagName="h4"
                    className="certificate-label"
                  />
                  <FormattedMessage
                    id="COMPANY_CERTIFICATE_ORGANISATION"
                    tagName="h4"
                    className="certificate-label"
                  />
                  <label className="normalizeSpace">&nbsp;</label>
                </div>
              )}
              {Certificates.length > 0 &&
                Certificates.slice(0, 2).map((certificaat, index) => (
                  <div className="section-array">
                    <Input
                      name="Participation"
                      value={certificaat.Participation}
                      readOnly
                      isEditOrCreate={false}
                    />
                    <Input
                      name="RegistrationNumber"
                      value={certificaat.RegistrationNumber}
                      readOnly
                      isEditOrCreate={false}
                    />
                    <Input
                      name="CertificationOrganization"
                      value={certificaat.CertificationOrganization}
                      readOnly
                      isEditOrCreate={false}
                    />
                    {/* <Button
                      kind="primary"
                      type="button"
                      className="p-10 remove-btn"
                    >
                      MINUS_SIGN
                    </Button> */}
                  </div>
                ))}
            </div>
          </div>

          <BackgroundBlock className="advice-form custom-header">
            <FormattedMessage id="COMPANY_OTHER_DETAILS" tagName="h2" />
          </BackgroundBlock>
          <div className="line-below"></div>
          <div className="company-details-section">
            <div className="company-details-section-one">
              <Input
                name="CNBMember"
                label="COMPANY_CNB_LID"
                placeholder="COMPANY_CNB_LID"
                hasTooltip={true}
                tooltipText="COMPANY_CNB_MEMBERSHIP_TOOLTIP"
                value={CNBMember}
                isEditOrCreate={false}
                disabled
              />
              {CNBMember.toLowerCase() === "ja" && (
                <CNBDatePicker
                  containerClassName="cnb-input"
                  className="date-picker"
                  name="CNBMemberFrom"
                  label="COMPANY_CNB_MEMBER_FORM"
                  startDate={
                    CNBMember.toLowerCase() === "ja" ? CNBMemberFrom : null
                  }
                  disabled
                />
              )}
              <Input
                name="EDI_code"
                label="COMPANY_EDI_CODE"
                placeholder="COMPANY_EDI_CODE"
                value={EDICode}
                isEditOrCreate={false}
                disabled
              />
            </div>
            <div className="company-details-section-two">
              <Input
                name="DigitalCommunication"
                label="COMPANY_DIGITAL"
                hasTooltip={true}
                tooltipText="COMPANY_DIGITAL_TOOLTIP"
                placeholder="COMPANY_DIGITAL"
                value={DigitalCommunication}
                isEditOrCreate={false}
                disabled
              />
            </div>
          </div>
          {_.includes(roles, "GebruikersBeheer") && (
            <div className="button-container">
              <Button
                type="submit"
                kind="primary"
                className="animate-bg bg-white"
                onClick={this.checkPermissionLevelAndNavigate}
              >
                COMPANY_INFORMATION_EDIT
              </Button>
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    companyInformation: state.companyInformation.companyDetail,
    roleIds: state.app.roleIds,
    user: state.app.user,
    roles: state.app.roles,
  }),
  {
    getCompanyInformation:
      companyInformationActions.getCompanyInformationForCustomer,
  }
)(injectIntl(CompanyInformation));
